import XMLViewer from './XMLViewer';

export default XMLViewer;